import { ScheduleEntryStatus } from "./DetailedItem";

/**
 * Overflow-menu actions for the scheduler appointment view, in display order.
 * Cancelled appointments are inert (no edit/move/copy/deposit) but can still be deleted.
 */
export function getAppointmentMenuActions({ status, canAddDeposit }) {
  if (status === ScheduleEntryStatus.Canceled) {
    return ["delete"];
  }

  const actions = ["edit", "reschedule", "copy"];
  if (canAddDeposit) {
    actions.push("deposit");
  }
  actions.push("delete");
  return actions;
}
